import { createEvent, createStore } from 'effector';
export const updatePrevLocation = createEvent();
export const prevLocation = createStore('').on(updatePrevLocation, (_, payload) => payload);
